import { useNavigate } from "react-router-dom";
import { StyledTd, StyledTr } from "src/styled";
import { unifyDate } from "src/utils";

import { IGenericLoginsRow } from "./GenericLogins.types";

type Props = IGenericLoginsRow;
const GenericLoginsRow = ({ name, datecreated, email, genid }: Props) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`./edit-login/${genid}`);
  };
  return (
    <StyledTr onClick={handleClick} hover pointer>
      <StyledTd>{name}</StyledTd>
      <StyledTd>{email}</StyledTd>
      <StyledTd>{unifyDate(datecreated)}</StyledTd>
    </StyledTr>
  );
};
export default GenericLoginsRow;
